import * as React from "react"

const ResumeExperience = (): any => {
    React.useEffect(() => {
        if (window.opener)
            window.opener.postMessage({ loginSuccess: true });
    }, [])
    return null;
};

export default ResumeExperience